export class SuccessResult {
  success: boolean = false;
  message?: string = null;
}
